/**
 * Processamento de itens com subitens
 * Funções para processar listas de itens e agrupar subitens
 */

import { escapeLatexPreservandoComandos } from '../core/latex-utils';

/**
 * Remove comandos \textbf{...} do texto, mantendo apenas o conteúdo interno
 * @param text Texto que pode conter comandos \textbf{...}
 * @returns Texto sem os comandos \textbf{...}
 */
function removerNegritos(text: string): string {
  if (!text) return text;

  // Remover \textbf{...} recursivamente (pode haver negritos aninhados)
  let resultado = text;
  let mudou = true;

  while (mudou) {
    const antes = resultado;
    // Remover \textbf{conteudo} substituindo por apenas conteudo
    resultado = resultado.replace(/\\textbf\{([^{}]*(?:\{[^{}]*\}[^{}]*)*)\}/g, '$1');
    mudou = antes !== resultado;
  }

  return resultado;
}

/**
 * Processa uma lista de itens e agrupa subitens (que começam com "+") com seus itens principais
 * Remove negritos de todos os itens
 * @param items Array de strings com itens e subitens
 * @returns Array de strings em formato LaTeX com itens e subitens aninhados
 */
export function processarItensComSubitens(items: string[]): string[] {
  const resultado: string[] = [];
  let currentItem: string | null = null;
  const subitems: string[] = [];

  for (const item of items) {
    const trimmed = item.trim();
    // Remover negritos do item antes de processar
    const itemSemNegrito = removerNegritos(trimmed);

    if (itemSemNegrito.startsWith('+')) {
      // É um subitem - remover o "+" e adicionar aos subitens do item atual
      const subitemText = itemSemNegrito.substring(1).trim();
      if (subitemText) {
        subitems.push(subitemText);
      }
    } else {
      // É um item principal - primeiro salvar o item anterior com seus subitens
      if (currentItem !== null) {
        if (subitems.length > 0) {
          const subitemsLatex = subitems.map(s => `\\item ${escapeLatexPreservandoComandos(removerNegritos(s))}`).join('\n                ');
          resultado.push(`\\item ${escapeLatexPreservandoComandos(removerNegritos(currentItem))}\n            \\begin{itemize}\n                ${subitemsLatex}\n            \\end{itemize}`);
        } else {
          resultado.push(`\\item ${escapeLatexPreservandoComandos(removerNegritos(currentItem))}`);
        }
        subitems.length = 0; // Limpar array
      }
      currentItem = itemSemNegrito;
    }
  }

  // Adicionar o último item
  if (currentItem !== null) {
    if (subitems.length > 0) {
      const subitemsLatex = subitems.map(s => `\\item ${escapeLatexPreservandoComandos(removerNegritos(s))}`).join('\n                ');
      resultado.push(`\\item ${escapeLatexPreservandoComandos(removerNegritos(currentItem))}\n            \\begin{itemize}\n                ${subitemsLatex}\n            \\end{itemize}`);
    } else {
      resultado.push(`\\item ${escapeLatexPreservandoComandos(removerNegritos(currentItem))}`);
    }
  }

  return resultado;
}


